import { stringify } from 'qs';
import { IS_ONPREMISE, LOGIN_URL } from 'reactApp/appHelpers/configHelpers';

export const showAuth = (params) => {
    if (IS_ONPREMISE) {
        const { successPage: page = location.href, type: action, ...rest } = params;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.location = `${LOGIN_URL}?${stringify({ page, action, ...rest })}`;
        return;
    }

    window.__PH.authForm.show(params);
};
